import { CFTokens } from '../../../../tokens';
export const SELECT_FIELD_OPTION_BACKGROUND = {
    DEFAULT: CFTokens.COLOR.TRANSPARENT,
    HOVER: CFTokens.COLOR.BACKGROUND_WARM_2,
    SELECTED: CFTokens.COLOR.BACKGROUND_WARM_2,
};
export const SELECT_FIELD_OPTION_LIST_GAP = {
    DEFAULT: 0,
    MULTIPLE: CFTokens.SPACER.B,
};
export const SELECT_FIELD_OPTION_MIN_HEIGHT = CFTokens.SIZE.F;
